function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7423 0L9.96914 11.0042L9.52334 8.63212L8.19239 1.44095C8.19239 1.44095 8.03087 0 6.31228 0H0.0710697L0 0.271878C0 0.271878 1.90596 0.686491 4.14142 2.10026L7.57861 16H11.7007L18 0.00679696H13.7423V0Z",
  fill: "#1A2362"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.52334 8.63212L8.19239 1.44095C8.19239 1.44095 8.03087 0 6.31228 0H0.0710697L0 0.271878C0 0.271878 2.99785 0.924384 5.87294 3.37808C8.62527 5.71623 9.52334 8.63212 9.52334 8.63212Z",
  fill: "#1A2362"
});

function SvgIconVisaSingle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisaSingle);
export default __webpack_public_path__ + "static/media/icon-visa-single.a369a0ea.svg";
export { ForwardRef as ReactComponent };